var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMountainSun = function SvgMountainSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 225,
    height: 95,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mountain-sun_svg__a",
    width: 225,
    height: 95,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.238.349h224.508v94H.238z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mountain-sun_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.04,
    cy: 26.393,
    r: 21.694,
    fill: "#F6BC2D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    d: "M85.052 107.678c-3.572-.004-5.349-4.33-2.81-6.843l72.366-71.628a4 4 0 0 1 5.657.03l71.037 71.769c2.501 2.527.708 6.817-2.847 6.813z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    d: "M20.645 107.814c-3.571-.001-5.352-4.326-2.816-6.841l55.537-55.067a4 4 0 0 1 5.657.024l54.612 55.079c2.504 2.525.715 6.816-2.841 6.816z"
  }))));
};
export { SvgMountainSun as ReactComponent };
export default __webpack_public_path__ + "images/mountain-sun.svg";